"use client";

// must render as a client component, otherwise there if there are no other client components that use fontawesome rendered on the page, the fontawesome styles will not be applied and you get a giant chevron
import Link, { LinkProps } from "next/link";

import {
  ButtonContent,
  type CommonButtonProps,
  createButtonClassNames,
  determineIcon,
} from "./common-button-resources";

type LinkButtonProps = {
  href: string;
  text: string;
} & CommonButtonProps &
  LinkProps;

export function LinkButton({
  chevron,
  className,
  color,
  href,
  iconRight,
  size,
  variant,
  text,
  ...rest
}: LinkButtonProps) {
  const classNames = createButtonClassNames({
    className,
    color,
    iconRight,
    size,
    variant,
  });

  if (!href) {
    throw new Error("Link must have a href");
  }

  const icon = determineIcon({ chevron, iconRight });

  return (
    <Link className={classNames} href={href} {...rest}>
      <ButtonContent icon={icon} text={text} />
    </Link>
  );
}
